export const Theme = {
    button: 'min-w-[128px]',
  };
  